module.exports = __webpack_public_path__ + "static/media/fr.d7587684.png";